Object.defineProperty(exports, '__esModule', { value: true });

var CheckmarkCompactMIcon = require('@alfalab/icons-glyph/CheckmarkCompactMIcon');
var CheckmarkCompactSIcon = require('@alfalab/icons-glyph/CheckmarkCompactSIcon');
var ClockHandsCompactMIcon = require('@alfalab/icons-glyph/ClockHandsCompactMIcon');
var ClockHandsCompactSIcon = require('@alfalab/icons-glyph/ClockHandsCompactSIcon');
var CrossCompactMIcon = require('@alfalab/icons-glyph/CrossCompactMIcon');
var CrossCompactSIcon = require('@alfalab/icons-glyph/CrossCompactSIcon');
var ExclamationCompactMIcon = require('@alfalab/icons-glyph/ExclamationCompactMIcon');
var ExclamationCompactSIcon = require('@alfalab/icons-glyph/ExclamationCompactSIcon');
var InformationCompactMIcon = require('@alfalab/icons-glyph/InformationCompactMIcon');
var InformationCompactSIcon = require('@alfalab/icons-glyph/InformationCompactSIcon');
var StopBrickCompactMIcon = require('@alfalab/icons-glyph/StopBrickCompactMIcon');
var StopBrickMIcon = require('@alfalab/icons-glyph/StopBrickMIcon');
var StopBrickSIcon = require('@alfalab/icons-glyph/StopBrickSIcon');

var ICON_MAP = {
    'positive-checkmark': {
        16: CheckmarkCompactSIcon.CheckmarkCompactSIcon,
        20: CheckmarkCompactSIcon.CheckmarkCompactSIcon,
        24: CheckmarkCompactMIcon.CheckmarkCompactMIcon,
        32: CheckmarkCompactMIcon.CheckmarkCompactMIcon,
        40: CheckmarkCompactMIcon.CheckmarkCompactMIcon,
    },
    'negative-cross': {
        16: CrossCompactSIcon.CrossCompactSIcon,
        20: CrossCompactSIcon.CrossCompactSIcon,
        24: CrossCompactMIcon.CrossCompactMIcon,
        32: CrossCompactMIcon.CrossCompactMIcon,
        40: CrossCompactMIcon.CrossCompactMIcon,
    },
    'negative-alert': {
        16: ExclamationCompactSIcon.ExclamationCompactSIcon,
        20: ExclamationCompactSIcon.ExclamationCompactSIcon,
        24: ExclamationCompactMIcon.ExclamationCompactMIcon,
        32: ExclamationCompactMIcon.ExclamationCompactMIcon,
        40: ExclamationCompactMIcon.ExclamationCompactMIcon,
    },
    'negative-block': {
        16: StopBrickSIcon.StopBrickSIcon,
        20: StopBrickSIcon.StopBrickSIcon,
        24: StopBrickCompactMIcon.StopBrickCompactMIcon,
        32: StopBrickMIcon.StopBrickMIcon,
        40: StopBrickMIcon.StopBrickMIcon,
    },
    'attention-alert': {
        16: ExclamationCompactSIcon.ExclamationCompactSIcon,
        20: ExclamationCompactSIcon.ExclamationCompactSIcon,
        24: ExclamationCompactMIcon.ExclamationCompactMIcon,
        32: ExclamationCompactMIcon.ExclamationCompactMIcon,
        40: ExclamationCompactMIcon.ExclamationCompactMIcon,
    },
    'neutral-information': {
        16: InformationCompactSIcon.InformationCompactSIcon,
        20: InformationCompactSIcon.InformationCompactSIcon,
        24: InformationCompactMIcon.InformationCompactMIcon,
        32: InformationCompactMIcon.InformationCompactMIcon,
        40: InformationCompactMIcon.InformationCompactMIcon,
    },
    'neutral-operation': {
        16: ClockHandsCompactSIcon.ClockHandsCompactSIcon,
        20: ClockHandsCompactSIcon.ClockHandsCompactSIcon,
        24: ClockHandsCompactMIcon.ClockHandsCompactMIcon,
        32: ClockHandsCompactMIcon.ClockHandsCompactMIcon,
        40: ClockHandsCompactMIcon.ClockHandsCompactMIcon,
    },
    'neutral-cross': {
        16: CrossCompactSIcon.CrossCompactSIcon,
        20: CrossCompactSIcon.CrossCompactSIcon,
        24: CrossCompactMIcon.CrossCompactMIcon,
        32: CrossCompactMIcon.CrossCompactMIcon,
        40: CrossCompactMIcon.CrossCompactMIcon,
    },
};

exports.ICON_MAP = ICON_MAP;
